import { createFileRoute, Outlet, Link } from "@tanstack/react-router";
// helpers
import { useAccessPermission } from "@/helpers/acessPermission";

// UI
import NotPermission from "@/components/NotPermission";
// Constants
import siteConfig from "@/config/site";
export const Route = createFileRoute(
  "/_layout-private/account-management/soe/_information"
)({
  component: SOEInformationLayout,
});

function SOEInformationLayout() {
  const { company_management } = useAccessPermission();
  return company_management.isRead ? (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold">ຈັດການຂໍ້ມູນບໍລິສັດ</h1>
        <p className="text-muted-foreground">ຂໍ້ມູນທັງໝົດກ່ຽວກັບລັດວິສາຫະກິດ</p>
      </div>
      <div className="flex relative flex-row gap-2 mt-2 w-full">
        <nav className="w-[20%] sticky top-0">
          <ul>
            {siteConfig.soeInformationMenus.map((menu) => (
              <li key={menu.name}>
                <Link
                  to={menu.href}
                  className="px-4 py-2 rounded-md  flex items-center [&.active]:font-bold [&.active]:bg-muted [&.active]:text-primary  text-[14px] "
                >
                  {menu.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="w-[80%] px-4 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    <NotPermission />
  );
}
